import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import { authApi } from "../api/authApi";

export function useAuth() {
  const queryClient = useQueryClient();
  const queryKey = ["auth/profile"];
  const token = localStorage.getItem("token");

  // ===== GET PROFILE (chỉ gọi 1 lần, cache lại) =====
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery({
    queryKey,
    queryFn: async () => await authApi.getProfile(),
    enabled: !!token, // chỉ gọi nếu có token
    staleTime: 1000 * 60 * 5, // cache profile 5 phút
    gcTime: 1000 * 60 * 30, // lưu cache lâu hơn 30p
    retry: false,
  });

  // ===== LOGIN =====
  const login = useMutation({
    mutationFn: async (body) => await authApi.login(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  // ===== REGISTER =====
  const register = useMutation({
    mutationFn: async (body) => await authApi.register(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  // ===== SEND OTP =====
  const sendOtp = useMutation({
    mutationFn: (body) => authApi.sendOtp(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  // ===== VERIFY OTP =====
  const verifyOtp = useMutation({
    mutationFn: async (body) => await authApi.verifyOtp(body),
    onSuccess: (data) => {
      if (!data) return;

      localStorage.setItem("token", data.token);
      localStorage.setItem("refreshToken", data.refreshToken);

      message.success("Xác thực mã OTP thành công");

      queryClient.invalidateQueries({ queryKey });
    },
  });

  // ===== RESET PASSWORD =====
  const resetPassword = useMutation({
    mutationFn: async (body) => await authApi.resetPassword(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  // ===== LOGOUT (xoá cache + token) =====
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");

    // Xóa cache profile trong React Query
    queryClient.removeQueries({ queryKey });

    message.success("Đăng xuất thành công");
  };

  return {
    login,
    register,
    logout,
    data,
    loading,
    error,
    sendOtp,
    verifyOtp,
    resetPassword,
  };
}
